import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {   BulkPatchTemplatePayloadType,  communicationTemplateState,  getAllTemplatesPayload} from '../types/templateManager.types'


const initialState: communicationTemplateState = {
  content: {},
  selected: null,
}

const templateManagerSlice = createSlice({
  name: 'templateManager',
  initialState: initialState,
  reducers: {
    updateTemplatesContent : (state : communicationTemplateState , action) => {
      state.content = action.payload;
    },
    updateSelectedTemplate : (state :communicationTemplateState ,  action) =>{
      if(action?.payload){
        state.selected = action.payload;
      }
    },
    resetSelectedTemplate : (state : communicationTemplateState) => {
      state.selected = null;
    },
    addTemplateAction: (state : communicationTemplateState , _action) => {
      return state
    },
    getTemplateByIdAction: (state : communicationTemplateState, _action) => {
      return state
    },
    getAllTemplatesAction: (state : communicationTemplateState , _action : PayloadAction<getAllTemplatesPayload>) => {
      return state;
    },
    getEmailTemplateByCorrespondenceTypeAndProgramAction:()=>{ 
      return
    },
    updateTemplateAction: (state : communicationTemplateState, _action) => {
      return state
    },
    deleteTemplateByIdAction: (state : communicationTemplateState, _action) => {
      return state
    },
    patchBulkToggleTemplateAction: (state, _action: PayloadAction<BulkPatchTemplatePayloadType>) => {
      return state;
    },
    addTemplateSaveAsDraftAction: (state : communicationTemplateState , _action) => {
      return state
    },
    attachmentPreviewAction: (state, action) => {
       return {...state, ...action}
    },
    showSelectedDocumentTemplate: (state, action) => {
      state.content = action.payload
    },
  },
})

export const {
  updateSelectedTemplate,
  updateTemplatesContent,
  addTemplateAction,
  getTemplateByIdAction,
  getAllTemplatesAction,
  updateTemplateAction,
  deleteTemplateByIdAction,
  getEmailTemplateByCorrespondenceTypeAndProgramAction,
  patchBulkToggleTemplateAction,
  resetSelectedTemplate,
  addTemplateSaveAsDraftAction,
  attachmentPreviewAction,
  showSelectedDocumentTemplate
} = templateManagerSlice.actions
export default templateManagerSlice.reducer
